import {Injectable} from '@angular/core';
export class BrowserXhr {
  constructor() {}
  build(): any { return <any>(new XMLHttpRequest()); }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
static ctorParameters: {type: Function, decorators?: DecoratorInvocation[]}[] = [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
